// Generated by tools/vite/ca-registry.mjs from the tax cabinet's own CAs.json.
// Do not edit by hand: `apps/web`'s Vite build refreshes it on start, and
// `npm run update:ca-registry` regenerates it on its own.
//
// Every ЦСК with a CMP service, in the order the tax cabinet lists them. The
// sign-in screen needs the whole list so a user can find their issuer before
// anything is read — a missing one is a key that cannot be read at all. ДПС
// changes it only a few times a year, so it is baked into the bundle rather
// than fetched in the browser on every visit.

export const CERTIFICATE_AUTHORITIES = [
  { name: "КНЕДП ДПС", cmpUrl: "http://ca.tax.gov.ua/services/cmp/" },
  {
    name: '"Дія". Кваліфікований надавач електронних довірчих послуг',
    cmpUrl: "http://ca.informjust.ua/services/cmp/",
  },
  {
    name: "КНЕДП ЦСК Укрзалізниці",
    cmpUrl: "http://csk.uz.gov.ua/services/cmp/",
  },
  {
    name: 'КНЕДП "MASTERKEY" ТОВ "АРТ-МАСТЕР"',
    cmpUrl: "http://masterkey.ua/services/cmp/",
  },
  { name: 'КНЕДП ДП "УСС"', cmpUrl: "http://csk.uss.gov.ua/services/cmp/" },
  {
    name: 'КНЕДП АТ "УКРСИББАНК"',
    cmpUrl: "http://csk.ukrsibbank.com/services/cmp/",
  },
  {
    name: 'КНЕДП АЦСК АТ КБ "ПриватБанк"',
    cmpUrl: "http://acsk.privatbank.ua/services/cmp/",
  },
  {
    name: 'КНЕДП АТ "Сенс Банк"',
    cmpUrl: "http://ca.sensebank.com.ua/services/cmp/",
  },
  {
    name: 'КНЕДП Акціонерного товариства "КРЕДІ АГРІКОЛЬ БАНК"',
    cmpUrl: "http://ca.credit-agricole.ua/services/cmp/",
  },
  { name: 'КНЕДП АТ "ПУМБ"', cmpUrl: "http://pki.pumb.ua/services/cmp/" },
  {
    name: 'КНЕДП ТОВ "ДЕПОЗИТ САЙН"',
    cmpUrl: "http://ca.depositsign.com/services/cmp/",
  },
  {
    name: 'КНЕДП ТОВ "Вчасно Сервіс"',
    cmpUrl: "http://ca.vchasno.ua/services/cmp/",
  },
  {
    name: "КНЕДП “ЦСК Збройних Сил України”",
    cmpUrl: "http://ca.mil.gov.ua/services/cmp/",
  },
  {
    name: 'КНЕДП "Військова частина 2428" ДПСУ',
    cmpUrl: "http://acsk.dpsu.gov.ua/services/cmp/",
  },
  { name: "КНЕДП НГУ", cmpUrl: "http://ca.ngu.gov.ua/services/cmp/" },
  {
    name: 'КНЕДП "АЦСК ринку електричної енергії"',
    cmpUrl: "http://acsk.oree.com.ua/services/cmp/",
  },
  {
    name: "КНЕДП - АЦСК МВС України",
    cmpUrl: "http://ca.mvs.gov.ua/services/cmp/",
  },
  {
    name: "КНЕДП Служби зовнішньої розвідки України",
    cmpUrl: "http://ca.szru.gov.ua/services/cmp/",
  },
  {
    name: "АЦСК Національного банку України",
    cmpUrl: "http://canbu.bank.gov.ua/services/cmp/",
  },
  {
    name: 'КНЕДП АТ "ПРАВЕКС БАНК"',
    cmpUrl: "http://ca.pravex.com.ua/services/cmp/",
  },
  {
    name: 'КНЕДП АТ "ТАСКОМБАНК"',
    cmpUrl: "http://ca.tascombank.ua/services/cmp/",
  },
  {
    name: 'КНЕДП ТОВ "АМО ФІНТЕХ"',
    cmpUrl: "http://amokey.com.ua/services/cmp/",
  },
  {
    name: "КНЕДП EDIN ID ТОВ “АТС”",
    cmpUrl: "http://ca.edin.ua/services/cmp/",
  },
  {
    name: 'КНЕДП ТОВ "Центр сертифікації ключів "Україна"',
    cmpUrl: "http://uakey.com.ua/services/cmp/",
  },
  {
    name: "КНЕДП органів прокуратури України",
    cmpUrl: "http://ca.gp.gov.ua/cmp",
  },
  {
    name: "КНЕДП СБ України",
    cmpUrl: "http://va1-knedp.ssu.gov.ua/services/cmp/",
  },
  {
    name: 'КНЕДП "eSign" ТОВ "Ілайф"',
    cmpUrl: "http://cmp.e-life.com.ua/api/PKI/CMP",
  },
  { name: 'КНЕДП АТ "БАНК АЛЬЯНС"', cmpUrl: "http://ca.bankalliance.ua/cmp" },
  { name: 'КНЕДП АБ "УКРГАЗБАНК"', cmpUrl: "http://qca.ukrgasbank.com/cmp" },
  {
    name: "КНЕДП monobank | Universal Bank",
    cmpUrl: "http://ca.monobank.ua/services/cmp/",
  },
];
